<label [class.visually-hidden]="noLabel" *transloco="let t" [for]="localeLabelFor">{{
  t('Current location')
}}</label>

<ng-select
  [labelForId]="localeLabelFor"
  [searchable]="false"
  [clearable]="false"
  [hideSelected]="true"
  [formControl]="localeControl"
>
  @for (option of availableLocales; track option.locale) {
    <ng-option [value]="option.locale">
      @if (option.locale === localeControl.value) {
        <div class="selected-container">
          <img ngSrc="assets/svg/{{ option.locale }}.svg" alt="" width="18" height="14" />
          {{ option.localeData.languageName }} ({{ option.localeData.currency }})
        </div>
      } @else {
        <a [href]="'/' + option.locale" [hreflang]="option.locale">
          <img ngSrc="assets/svg/{{ option.locale }}.svg" alt="" width="18" height="14" />
          {{ option.localeData.languageName }} ({{ option.localeData.currency }})
        </a>
      }
    </ng-option>
  }
</ng-select>
